import React from 'react';
import { Box } from '../../../Box';
import { dataTableClassnames } from '../const/classNames';
import { Pagination } from './pagination/Pagination';

export const Footer: React.FC = () => {
  return (
    <Box className={dataTableClassnames.footer.root}>
      <Pagination />
    </Box>
  );
};
